<template>
</template>

<script>
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesSalesOrdersPickListPrint',
  mixins: [printHtml],
  props: {
    salesOrder: {type:Object, required:true},
  },
  async created() {
    this.$emit('done');
    const results = await this.$apiCall(`query SalesSalesOrdersPickListPrint($id:ID!) {
                                            salesOrder(id:$id) {
                                              date,due,number,customerName,shipToAddress
                                              lines {
                                                sku,description,quantity,units,precision,picked
                                                items {sku,description,quantity,units,precision}
                                              }
                                            }
                                          }`,
                                        {id:this.salesOrder.id});
    if (results.error)
      return;
    const salesOrder = results.data.salesOrder;

    const lines = [`
      <style>
        @page {size:portrait}
        .pick-list-print {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;text-align:left;border-collapse:collapse;table-layout:fixed}
        .pick-list-print th {font-weight:normal;vertical-align:top}
        .pick-list-print .header {dborder:1px solid #888;text-align:center;padding:4px 8px}
        .pick-list-print .title {background-color:#b4b4b4}
        .pick-list-print td {padding:8px 8px}
        .pick-list-print .right {text-align:right}
        .pick-list-print .left {text-align:left}
        .pick-list-print .line {border-bottom:1px solid #000}
        .diagonal-status {
          position:absolute;
          font-size:200px;
          opacity:0.2;
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          left:50px;
          top:300px;
          pointer-events: none;
          z-index:100	;
        }
      </style>
      <table class="pick-list-print">
        <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
        <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
        <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
        <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
        <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
        <thead>
          <tr>
            <th style="color:#aaa;font-size:36px;font-weight:700;padding-bottom:20px" colspan="20">PICK LIST</th>
          </tr>
          <tr>
            <th colspan="5" class="header title">SHIP TO</th>
            <th colspan="3" rowspan="2"/>
            <th colspan="4" class="header title">ORDER #</th>
            <th colspan="4" class="header title">DATE</th>
            <th colspan="4" class="header title">EXPECTED #</th>
          </tr>
          <tr>
            <th colspan="5" rdowspan="5" class="header">
              ${this.displayAddress(salesOrder.shipToAddress)}
            </th>
            <th colspan="4" class="header">${salesOrder.number || ''}</th>
            <th colspan="4" class="header">${this.$formatDate(salesOrder.date)}</th>
            <th colspan="4" class="header">${salesOrder.due ? this.$formatDate(salesOrder.due) : 'TBD'}</th>
          </tr>
          <tr><th colspan="20">&nbsp;</th></tr>
          <tr>
            <th colspan="3" class="header title left">ITEM</th>
            <th colspan="10" class="header title left">DESCRIPTION</th>
            <th colspan="4" class="header title right">QTY</th>
            <th colspan="3" class="header title right">PICKED</th>
          </tr>
        </thead>
        <tbody>`];

      salesOrder.lines.forEach(line => {
        if (line.items)
          line.items.forEach(bundleLine => {
            lines.push(`<tr>
                          <td colspan="3">${bundleLine.sku}</td>
                          <td colspan="11">${bundleLine.description}</td>
                          <td colspan="3" class="right">${this.$number(bundleLine.quantity, bundleLine.precision)} ${bundleLine.units}</td>
                          <td colspan="3" class="line"></td>
                        </tr>`);
          });
        else {
          lines.push(`<tr>
                        <td colspan="3">${line.sku}</td>
                        <td colspan="11">${line.description}</td>
                        <td colspan="3" class="right">${this.$number(line.quantity, line.precision)} ${line.units}</td>
                        <td colspan="3" class="right line">${line.picked ? `${this.$number(line.picked, line.precision)}` : ``}</td>
                      </tr>`);
        }
      });

    this.printHtml('Pick list', lines.join(''));
  },

  methods: {
    displayAddress(address) {
      let count = (address.match(/\n/g) || []).length
      let display = address.replace(/\n/gi,'<br/>');
      while (count++ < 2)   // Make sure we have at least 3 lines
        display += '<br/>';
      return display;
    }
  }
}
</script>